module.exports = __webpack_public_path__ + "img/emoji-happy-off.ef3a6cb7.svg";